import { render } from "./StrokedChevronLeftIcon.vue?vue&type=template&id=6a441fca"
import script from "./StrokedChevronLeftIcon.vue?vue&type=script&lang=js"
export * from "./StrokedChevronLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__